import { makeStyles } from '@material-ui/core'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    '& .MuiDrawer-paper': {
      width: spacing(392),
      top: spacing(48),
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'transparent',
    },
  },
  header: {
    padding: spacing(16, 10, 10, 32),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  iconWrapper: {
    width: spacing(32),
    height: spacing(32),
    fontSize: spacing(18),
    borderRadius: '50%',
    backgroundColor: Theme.Colors.Primary.Lightest,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: spacing(12),
  },
  icon: {
    width: spacing(16),
    height: spacing(16),
  },
  closeIcon: {
    width: spacing(24),
    height: spacing(24),
    fontSize: spacing(12),
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    color: Theme.Colors.Primary.Base,
    fontWeight: 500,
  },
  divider: {
    backgroundColor: Theme.Colors.Primary.Base,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: spacing(32, 32, 64),
    height: '84%',
    overflowY: 'auto',
    marginBottom: spacing(128),
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: spacing(24),
    position: 'fixed',
    bottom: 0,
    right: 0,
    backgroundColor: '#fff',
    height: spacing(88),
    width: spacing(392),
    padding: '24px 0',
  },
}))
